export default __webpack_public_path__ + "media/images/icon_grade-0368ff5400e0d458af3c2815bae7c50e.svg";